import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { Field, change, formValueSelector, getFormInitialValues } from 'redux-form';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import ToggleSwitch from 'components/atoms/form/ToggleSwitch';
import FormSubHeading from 'components/atoms/form/FormSubHeading';
import { INNOVID_DYNAMIC_CREATIVE_DIMENSION_INFO } from 'constants/dynamicCreatives';

const getFormValue = formValueSelector('editDynamicProfile');
const getInitialFormValue = getFormInitialValues('editDynamicProfile');

const DimensionHeading = styled(FormSubHeading)`
    height: 48px;
    line-height: 1.2;
    padding: 8px 0;
    vertical-align: middle;
`;

const dimensionDisplayText = (index, profileType) => {
    const idx = index - 1; // index starts at 1

    if (profileType === 'innovid') {
        const subtext = get(INNOVID_DYNAMIC_CREATIVE_DIMENSION_INFO, `${idx}.dimension_subtext`, 'N/A');
        return <div>
            <div>Dimension {index}</div>
            <div style={{ fontSize: '11px', textTransform: 'lowercase' }}>({subtext})</div>
        </div>;
    }

    return <span>Dimension {index}</span>;
};

const DimensionRowFormContainer = (props) => {
    const { index, change: changeValue, profileType } = props;
    const idx = index - 1; // index starts at 1
    let placeholder = '';

    if (profileType === 'innovid') {
        placeholder = get(INNOVID_DYNAMIC_CREATIVE_DIMENSION_INFO, `${idx}.label_default`, '');
    }

    return (
        <Row>
            <Col xs={3}>
                <DimensionHeading>
                    {dimensionDisplayText(index, profileType)}
                </DimensionHeading>
            </Col>
            <Col xs={3}>
                <Field component={TextInputAdmin} placeholder={placeholder} onChange={(event, value) => {
                    if (value && !props.showOnReportInitial && props.labelInitial) { return true; }
                    if (value && !props.showOnReport) { changeValue('editDynamicProfile', `meta.dimension${index}.showOnReport`, true); return true; }
                    if (!value && props.showOnReport) { changeValue('editDynamicProfile', `meta.dimension${index}.showOnReport`, false); return true; }
                    return true;
                }} name={`meta.dimension${index}.label`} type="text" required={false} format={null} />
            </Col>
            <Col xs={3}>
                <Field component={ToggleSwitch} name={`meta.dimension${index}.showOnReport`} type="text" />
            </Col>
        </Row>
    );
};

const mapStateToProps = (state, props) => ({
    label: getFormValue(state, `meta.dimension${props.index}.label`),
    showOnReport: getFormValue(state, `meta.dimension${props.index}.showOnReport`),
    showOnReportInitial: get(getInitialFormValue(state), `meta.dimension${props.index}.showOnReport`),
    labelInitial: get(getInitialFormValue(state), `meta.dimension${props.index}.label`)
});

export default connect(mapStateToProps, { change })(DimensionRowFormContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/dynamicProfiles/DimensionRowFormContainer.js